'use es6';

import { map } from 'rxjs/operators/map';
import { of } from 'rxjs/observable/of';
import http from 'hub-http-rxjs/clients/apiClient';
import Lists from '../models/Lists';
const EXPORTS_BASE_PATH = 'reports/v1/export';
const LISTS_BASE_PATH = 'contacts/v1';
const STATIC_LIST_TYPE = 'STATIC';
export default {
  create(name) {
    return http.post(`${LISTS_BASE_PATH}/lists`, {
      data: {
        name
      }
    });
  },

  exportToList(data, listId) {
    return http.post(`${EXPORTS_BASE_PATH}/reports_people_to_list_export_queue`, {
      data: data.set('listId', listId)
    });
  },

  fetchAllLists(offset, search) {
    return this.fetchLists(undefined, offset, search).pipe(map(Lists.fromListsJS));
  },

  fetchLists(listType, offset, search) {
    const query = {
      count: 50,
      direction: 'ASC',
      listType,
      offset: 0 || offset,
      q: search,
      sortBy: 'LIST_NAME'
    };
    return http.get(`${LISTS_BASE_PATH}/segment-ui/all`, {
      query
    });
  },

  fetchSpecificLists(listIds) {
    if (listIds.size === 0) {
      return of(Lists.fromSpecificListsJS({}));
    }

    return http.post(`${LISTS_BASE_PATH}/lists/batch`, {
      data: listIds.toArray()
    }).pipe(map(Lists.fromSpecificListsJS));
  },

  fetchStaticLists(offset, search) {
    return this.fetchLists(STATIC_LIST_TYPE, offset, search).pipe(map(Lists.fromStaticListsJS));
  }

};